import SwiperCore, { Autoplay, Navigation } from 'swiper/core';
import { randomNumber } from '../tools/basic-functions.js';
import { initPanelSlider } from './../homepage-slider/homepage-slider';

var _jackpotBanner = {};
window['_jackpotBanner'] = _jackpotBanner;

const jackpotsBannerTypes = {
  cashmesh: 'cash-mesh',
  bfgames: 'bf-games',
  guaranteed: 'guaranteed'
};

export async function initJackpots() {
  const jackpotData = await getJackpotsJson(true);
  var jackpots = getSelectedJackpots(jackpotData.jackpots);
  //TODO check if game available in this country
  if (document.querySelector('.jackpots .quantity')) {
    document.querySelector('.jackpots .quantity').innerHTML = jackpotData.jackpots.length;
  }
  const moduleGames = await import('../games/get-all-games');
  let allGames = await moduleGames.getAllGames();
  //await createJackpotPanelTotal(jackpotData.jackpots_sum, jackpotData.currency);
  for (var i = 0, len = jackpots.length; i < len; i++) {
    let jackpot = jackpots[i],
      game = findGameById(allGames, jackpot.GameId),
      gameName = game ? game.name : '';
    await createJackpotPanel(jackpot, gameName);
  }
  initPanelSlider('.panels.jackpots', 3, true);
}

// Main function to initialize the jackpot banner
export async function initJackpotBanner() {
  const jackpotBannerList = document.querySelectorAll('.jackpot-banner'),
    hiddenKey = 'jackpot-banner-hidden',
    lastKey = 'jackpot-banner-last',
    currentKey = 'jackpot-banner-current';

  let lastValue = localStorage.getItem(lastKey),
    currentValue = sessionStorage.getItem(currentKey);

  if (!currentValue) {
    const getCurrentValue = (lastValue) => {
      switch (lastValue) {
        case jackpotsBannerTypes.cashmesh:
          return jackpotsBannerTypes.bfgames;
        case jackpotsBannerTypes.bfgames:
          return jackpotsBannerTypes.guaranteed;
        case jackpotsBannerTypes.guaranteed:
        default:
          return jackpotsBannerTypes.cashmesh;
      }
    };

    currentValue = getCurrentValue(lastValue);
    localStorage.setItem(lastKey, currentValue);
    sessionStorage.setItem(currentKey, currentValue);
  }

  if (document.querySelector('.promotion-banner')) {
    const { initpromotionBanner } = await import('./promotion-banner.js');
    initpromotionBanner(currentValue !== jackpotsBannerTypes.guaranteed || sessionStorage.hasOwnProperty(hiddenKey));
  }

  for (const jackpotBanner of jackpotBannerList) {
    const jackpotBannerSlider = jackpotBanner.querySelector('.jackpot-banner-slider');
    const jackpotBannerSlideList = jackpotBannerSlider?.querySelectorAll('.jackpot-banner-slider-item');
    const jackpotList = jackpotBanner.querySelectorAll('.js-jackpot');

    if (jackpotList.length === 0) continue;

    const jackpotData = await getJackpotsJson();
    let jackpotInited = await processJackpots(jackpotList, jackpotData, jackpotBannerSlider);

    if (!jackpotInited) continue;

    handleBannerSlider(
      jackpotBannerSlider,
      jackpotBannerSlideList,
      jackpotBanner,
      jackpotBanner.getAttribute('data-provider') == currentValue
    );
    jackpotBanner.classList.remove('d-none');
    if (!_CMS_MOBILE && document.body.classList.contains('page-home'))
      handleBannerWidget(jackpotBanner, hiddenKey, currentValue);
  }
}

async function processJackpots(jackpotList, jackpotData, jackpotBannerSlider) {
  let jackpotInited = false;
  for (const jackpotEl of jackpotList) {
    jackpotInited = (await processJackpotElement(jackpotEl, jackpotData, jackpotBannerSlider)) || jackpotInited;
  }
  return jackpotInited;
}

async function processJackpotElement(jackpotEl, jackpotData, jackpotBannerSlider) {
  const jackpotGameID = jackpotEl?.getAttribute('data-game-id');
  const jackpotGamesType = jackpotEl?.getAttribute('data-type');

  if (!jackpotGameID && !jackpotGamesType) return false;

  let jackpotGameData = getJackpotGameData(jackpotGameID, jackpotGamesType, jackpotData);

  if (!jackpotGameData) {
    jackpotEl.parentElement.remove();
    return false;
  }

  addJackpotHandler(jackpotGameData, jackpotEl);

  if (jackpotBannerSlider) {
    jackpotEl.parentElement.classList.remove('d-none');
  }

  return true;
}

function getJackpotGameData(jackpotGameID, jackpotGamesType, jackpotData) {
  if (jackpotGameID) {
    return jackpotData.find(
      ({ GameId, jackpotsSum }) => GameId == jackpotGameID && (jackpotsSum == true || jackpotsSum == null)
    );
  }
  const filteredJackpots = jackpotData.filter(({ jackpotType }) => jackpotType == jackpotGamesType);

  return filteredJackpots.length > 0
    ? filteredJackpots.reduce((a, b) => (a.JackpotWinAmount > b.JackpotWinAmount ? a : b))
    : null;
}

function handleBannerSlider(jackpotBannerSlider, jackpotBannerSlideList, jackpotBanner, isBanner) {
  if (jackpotBannerSlider) {
    if (_CMS_MOBILE || jackpotBannerSlideList.length > 2 || (jackpotBannerSlideList.length > 1 && isBanner)) {
      initializeSwiper(jackpotBanner, isBanner);
    } else {
      adjustBannerSlideWidth(jackpotBannerSlideList, jackpotBannerSlider);
    }
  }
}

function initializeSwiper(jackpotBanner, isBanner) {
  SwiperCore.use([Navigation, Autoplay]);
  const slidesPerView = _CMS_MOBILE || isBanner ? 1 : 2;

  if (!_CMS_MOBILE && isBanner) {
    jackpotBanner.classList.add('jackpot-banner-single');
  }

  _jackpotBanner[jackpotBanner.getAttribute('data-provider')] = new SwiperCore('.jackpot-banner-slider', {
    slidesPerView: slidesPerView,
    loop: true,
    speed: 300,
    watchSlidesVisibility: true,
    /*on: {
        slideChange: () => {
          window.dispatchEvent(new Event("resize"));
        },
      },*/
    navigation: {
      nextEl: '.jackpot-banner-slider-next',
      prevEl: '.jackpot-banner-slider-previous'
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    }
  });

  toggleNavigationButtons(jackpotBanner);
}

function toggleNavigationButtons(jackpotBanner) {
  const nextEl = jackpotBanner.querySelector('.jackpot-banner-slider-next');
  const prevEl = jackpotBanner.querySelector('.jackpot-banner-slider-previous');
  const showMoreButton = jackpotBanner.querySelector('.jackpot-banner-more');
  nextEl?.classList.remove('d-none');
  prevEl?.classList.remove('d-none');
  showMoreButton?.classList.add('d-none');
}

function adjustBannerSlideWidth(jackpotBannerSlideList, jackpotBannerSlider) {
  for (const jackpotBannerSlide of jackpotBannerSlideList) {
    jackpotBannerSlide.style.width = `${100 / jackpotBannerSlideList.length}%`;
  }
  removeNavigationButtons(jackpotBannerSlider);
}

function removeNavigationButtons(jackpotBannerSlider) {
  const nextEl = jackpotBannerSlider.querySelector('.jackpot-banner-slider-next');
  const prevEl = jackpotBannerSlider.querySelector('.jackpot-banner-slider-previous');
  nextEl?.remove();
  prevEl?.remove();
}

function handleBannerWidget(jackpotBanner, hiddenKey, currentValue) {
  const isCurrent = currentValue == jackpotBanner.getAttribute('data-provider');
  const isHidden = sessionStorage.hasOwnProperty(hiddenKey);

  if (!jackpotBanner.classList.contains('jackpot-banner-widget')) {
    if (sessionStorage.hasOwnProperty(hiddenKey) || isCurrent) {
      parseToWidget(jackpotBanner);
    } else {
      addCloseButtonListener(jackpotBanner, hiddenKey);
    }
  } else if (isCurrent && !isHidden) {
    parseToBanner(jackpotBanner);
    addCloseButtonListener(jackpotBanner, hiddenKey);
  }
}

function addCloseButtonListener(jackpotBanner, hiddenKey) {
  const closeBtn = jackpotBanner.querySelector('.close');
  closeBtn.classList.remove('d-none');
  closeBtn?.addEventListener('click', async (e) => {
    e.preventDefault();
    const { setSessionStorageItem } = await import('../tools/basic-functions');
    setSessionStorageItem(hiddenKey, true);
    parseToWidget(jackpotBanner);
  });
}

function parseToBanner(el) {
  const parentEl = el.parentElement;
  if (parentEl?.tagName == 'SECTION') {
    parentEl.parentElement.insertBefore(el, parentEl);
    parentEl.remove();
  }
  el.classList.remove('jackpot-banner-widget');
}

function parseToWidget(el) {
  el.querySelector('.close').remove();
  el.querySelector('.jackpot-banner-more')?.classList.remove('d-none');

  const parentEl = el.parentElement;
  if (parentEl.tagName != 'SECTION') {
    const sectionEl = document.createElement('section');
    parentEl.insertBefore(sectionEl, el);
    sectionEl.appendChild(el);
  }

  if (el.classList.contains('jackpot-banner-single')) {
    const slider = _jackpotBanner[el.getAttribute('data-provider')];
    slider.params.slidesPerView = 2;
    slider.enabled = false;
    el.querySelector('.jackpot-banner-slider-next').remove();
    el.querySelector('.jackpot-banner-slider-previous').remove();
    el.classList.remove('jackpot-banner-single');
  }

  el.classList.add('jackpot-banner-widget');
}

/**
 * Returns array with jackpots
 * @returns {Array}
 */
export async function getJackpotsJson(all = false) {
  const moduleBasicFunc = await import('../tools/basic-functions.js');
  const jsonKey = `api/jackpots-list/?country=${_CMS_USERIP}&currency=`,
    localKey = `jackpots-list`;
  if (window[localKey]) {
    return all ? window[localKey] : window[localKey].jackpots;
  }
  const jsonUrl = moduleBasicFunc.getWalletURL(jsonKey),
    data = await moduleBasicFunc.getJSON(jsonUrl);
  window[localKey] = data;
  return all ? data : data.jackpots;
}

function getRandomElements(arr, num) {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, num);
}

function getSelectedJackpots(allJackpots) {
  let jackpotsIdList = [
    251370, 250944, 20854, 20855, 21661, 21662, 22146, 22147, 130708, 20834, 20835, 250932, 170387, 250924, 21631,
    21632, 23634, 23635, 23516, 23517, 23833
  ];

  const filteredJackpots = allJackpots.filter((jackpot) => jackpotsIdList.includes(jackpot.GameId));
  if (filteredJackpots.length >= 6) {
    return filteredJackpots;
  }

  if (allJackpots?.length > 10) {
    return getRandomElements(allJackpots, 10);
  }

  return [];
}

async function createJackpotPanel(item, gameName) {
  const modulePanels = await import('../tools/panels.js');
  const moduleBasicFunc = await import('../tools/tools-base');

  var panelEl = await modulePanels.createPanel('jackpots');
  panelEl.classList.add('swiper-slide');

  let thumbsnailSrc = _CMS_MOBILE ? '/images/uploads/games-thumbs/x175' : '/images/uploads/games-thumbs/x300';

  modulePanels.setPanelThumb(thumbsnailSrc + '/' + item.GameId + '.jpg', panelEl);
  modulePanels.setPanelBadge('Jackpot', panelEl);
  modulePanels.setPanelGame(gameName, panelEl);

  const jackpotEl = panelEl.querySelector('.panel-amount');
  jackpotEl.classList.add('js-jackpot');
  jackpotEl.textContent = jackpotAmount(item.JackpotWinAmount, item.currencyCode);
  moduleBasicFunc.fitTextToWrapper(panelEl.querySelector('.panel-content'), jackpotEl, true);
  addJackpotHandler(item, jackpotEl);
}
/*
async function createJackpotPanelTotal(sum, currencyCode) {
  /*
  *
  *  TO DEPLOY
  *  ASANA ([EC] Jackpot sliders+jackpot teasers)
  *
  * /
  /*if(!sum) return;
  const modulePanels = await import('../tools/panels.js');
  var panelEl = await modulePanels.createPanel('jackpots');
  panelEl.classList.add('swiper-slide');
  panelEl.classList.add('total');
  panelEl.querySelector('.panel-thumb').remove();
  const moduleTranslation = await import('../tools/translations');
  const totalJackpotLabel = await moduleTranslation.getTranslation('total_jackpot');
  modulePanels.setPanelBadge(totalJackpotLabel, panelEl);
  const jackpotEl = panelEl.querySelector('.panel-amount');
  jackpotEl.classList.add('js-jackpot');
  const jackpotFakeItem = {
    GrowthPerSecond: null,
    JackpotWinAmount: sum,
    currencyCode: currencyCode
  }
  addJackpotHandler(jackpotFakeItem, jackpotEl);
}*/

function findGameById(games, id) {
  return games.find((game) => game.id == id);
}

async function checkJackpotGameEl(jackpotGameEl) {
  if (!jackpotGameEl || !window['jackpots-list']) return;
  const jackpotGameID = jackpotGameEl.getAttribute('data-game-id');
  if (!jackpotGameID) return false;

  let jackpotEl = jackpotGameEl.querySelector('.js-jackpot');

  let jackpotGameData = null,
    jackpotData = await getJackpotsJson();

  jackpotGameData = jackpotData.find(
    ({ GameId, jackpotsSum }) => GameId == jackpotGameID && (jackpotsSum == true || jackpotsSum == null)
  );
  if (!jackpotGameData) return false;

  if (!jackpotEl) {
    let jackpotLabelsEl = jackpotGameEl.querySelector('.game-labels');
    if (jackpotLabelsEl) {
      const { createGameLabelsItemsEl } = await import('../games/modules/labels');
      jackpotEl = createEL(await createGameLabelsItemsEl(['jackpot']));
      jackpotLabelsEl.appendChild(jackpotEl);
      jackpotLabelsEl.classList.add('jackpot');
    } else {
      const { createGameLabelsEl } = await import('../games/modules/labels');
      jackpotLabelsEl = createEL(await createGameLabelsEl(null, ['jackpot']));
      jackpotGameEl.appendChild(jackpotLabelsEl);
      jackpotEl = jackpotLabelsEl.querySelector('.js-jackpot');
    }
  }
  if (jackpotEl.getAttribute('data-id')) return false;

  return { jackpotGameID, jackpotGameData, jackpotEl };
}

export async function addJackpot(jackpotGameEl) {
  const checkEl = await checkJackpotGameEl(jackpotGameEl);
  if (!checkEl) return;
  const { jackpotGameData, jackpotEl } = checkEl;
  addJackpotHandler(jackpotGameData, jackpotEl);
}

async function addJackpotHandler(jackpotGameData, jackpotEl) {
  const initedJackpots = getInitedJackpots();
  const alreadyGroup = initedJackpots.find(
    ({ growth, win }) => growth == jackpotGameData.GrowthPerSecond && win == jackpotGameData.JackpotWinAmount
  );

  if (alreadyGroup) {
    const otherCurrentValue = document.querySelector(`.js-jackpot[data-id="${alreadyGroup.id}"]`)?.textContent;
    if (otherCurrentValue) jackpotEl.textContent = otherCurrentValue;
    jackpotEl.setAttribute('data-id', alreadyGroup.id);
  } else {
    const id = Math.floor(Math.random() * Date.now());
    window['initedJackpots'].push({
      id: id,
      growth: jackpotGameData.GrowthPerSecond,
      win: jackpotGameData.JackpotWinAmount
    });
    jackpotEl.setAttribute('data-id', id);
    initUpdateJackpotGroup(jackpotGameData, id);
  }
}

function getInitedJackpots() {
  if (!window['initedJackpots']) {
    var initedJackpots = [];
    window['initedJackpots'] = initedJackpots;
    return initedJackpots;
  }
  return window['initedJackpots'];
}

export async function initUpdateJackpotGroup(jackpotGameData, id) {
  let jackpotMax = jackpotGameData.JackpotWinAmount,
    jackpotCurrency = jackpotGameData.currencyCode,
    jackpotGrowth = jackpotGameData.GrowthPerSecond ? parseFloat(jackpotGameData.GrowthPerSecond) : null,
    jackpotHalf = parseFloat(jackpotGameData.JackpotWinAmount / 2),
    jackpotCurrent = jackpotHalf,
    jackpotNumberInterval = jackpotHalf / 100,
    jackpotIntervalCounter = 0,
    interval = 0,
    intervalMax = 6000,
    jackpotMaxInterval = parseFloat(jackpotMax - jackpotNumberInterval),
    jackpotInterval;

  const refreshJackpot = () => {
    if (document.hidden) return;
    if (!(jackpotIntervalCounter <= 100 || isNaN(jackpotIntervalCounter))) {
      clearInterval(jackpotInterval);
      return;
    }
    if (interval > intervalMax) {
      interval = 0;
      clearInterval(jackpotInterval);
      setTimeout(
        () => {
          //jackpotEl.setAttribute('data-interval', ++jackpotIntervalCounter);
          jackpotInterval = setInterval(refreshJackpot, 50);
        },
        randomNumber(1500, 7000)
      );
      return;
    }
    if (jackpotGrowth === null && jackpotCurrent >= jackpotMaxInterval) jackpotCurrent = jackpotCurrent + 0.002;
    else
      jackpotCurrent =
        jackpotCurrent <= jackpotMaxInterval
          ? Math.floor((jackpotCurrent + jackpotNumberInterval) * 100) / 100
          : Math.floor((jackpotCurrent + jackpotGrowth / 15 + (jackpotGrowth > 1 ? 0.044 : 0)) * 100) / 100;
    const jackpotElList = document.querySelectorAll(`.js-jackpot[data-id="${id}"]`);
    for (const jackpotEl of jackpotElList) {
      jackpotEl.textContent = jackpotAmount(jackpotCurrent, jackpotCurrency);
    }

    interval = jackpotCurrent <= jackpotMaxInterval ? intervalMax : interval + randomNumber(50, 200);
  };

  jackpotInterval = setInterval(refreshJackpot, 50);
}

function jackpotAmount(amount, currency) {
  return `${parseFloat(amount).toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} ${currency}`;
}

const createEL = (domstring) => {
  const html = new DOMParser().parseFromString(domstring, 'text/html');
  return html.body.firstChild;
};
